import { render } from "./Lockers.vue?vue&type=template&id=35a0f5e8&scoped=true&ts=true"
import script from "./Lockers.vue?vue&type=script&lang=ts"
export * from "./Lockers.vue?vue&type=script&lang=ts"

import "./Lockers.vue?vue&type=style&index=0&id=35a0f5e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a0f5e8"]])

export default __exports__